// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1dM5A","title":"card_title__2TjuM","inActive":"card_inActive__67msO"};